import React, { useEffect, useRef } from 'react';
import { useTable, useFilters, useBlockLayout } from 'react-table'
import { FixedSizeList } from 'react-window'
import { Input } from 'semantic-ui-react'


export const TableListDiv = ({ props, columns, data, Actions, fn, setHeight, getIndex, filterBoxNone, rightBox, centerBox, callHeightFunc, paddingShort, getWidth, actionClass, scrollOnEdit, setScrollOnEdit }) => {

    const defaultColumn = React.useMemo(() => ({ Filter: DefaultColumnFilter, }), [])
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
            defaultColumn,
        }, useFilters,
        useBlockLayout
    )
    const divRef = useRef(null);

    function DefaultColumnFilter({
        column: { filterValue, preFilteredRows, setFilter, filteredRows },
    }) {
        const count = preFilteredRows.length

        React.useEffect(() => {
            if (callHeightFunc) {
                callHeightFunc();
            }
        }, []);

        return (
            <Input
                value={filterValue || ''}
                onChange={e => { setFilter(e.target.value || undefined) }}
                placeholder={`Search in ${count} records...`}
                style={{ width: '90%' }}
            />
        )
    }

    // use for scroll if list More
    useEffect(() => {
        if (data && data.length > 0) {
            if (scrollOnEdit && scrollOnEdit !== undefined && scrollOnEdit !== null && scrollOnEdit.status && scrollOnEdit.status !== undefined && scrollOnEdit.status !== null && scrollOnEdit.status === true) {
                if (divRef.current) {
                    let topGet = scrollOnEdit ? scrollOnEdit.top ? scrollOnEdit.top : 0 : 0
                    divRef.current.scrollToItem(topGet, "start");
                    setTimeout(function () {
                        let rowObj = document.getElementById("getRow" + topGet)
                        if (rowObj) {
                            if (topGet !== 0) {
                                rowObj.classList.add("showBackSelectedRow")
                            }
                        }
                        setTimeout(function () {
                            if (rowObj) {
                                rowObj.classList.remove("showBackSelectedRow")
                            }
                        }, 3000)
                    }, 500)
                }
            }
        }
    }, [data, scrollOnEdit])

    const tbodyRef = React.useRef(null);
    const RenderRow = React.useCallback(
        ({ index, style }) => {
            const row = rows[index]
            prepareRow(row)
            let i = 0;
            return (
                <div
                    {...row.getRowProps({
                        style,
                    })}
                    className={'tr bodyRow ' + (index % 2 === 0 ? 'evenRow' : 'oddRow') + ' getRowWise' + index}
                    id={'getRow' + index} tabIndex={1}
                >
                    <div className='slno'>{index + 1}</div>
                    {row.cells.map(cell => {
                        i++;
                        return (
                            <React.Fragment key={cell.column.id}>
                                <div {...cell.getCellProps()} className={'td ' + cell.render('classNameGet')}>
                                    {cell.render('Cell')}
                                </div>
                                {i === getIndex ?
                                    <div className={actionClass + " td centerBoxCol"}>
                                        <center>{Actions ? <Actions object={row.cells[0].row.original} fn={fn} idx={index} /> : <></>}</center>
                                    </div>
                                    :
                                    null
                                }
                            </React.Fragment>
                        )
                    })}
                </div>
            )
        },
        [prepareRow, rows]
    )
    let k = 0;
    // Render the UI for your table
    return (
        <div {...getTableProps()} className="table reactTableComm modernTable" style={{ width: getWidth }}>
            {headerGroups.map(headerGroup => (
                <div {...headerGroup.getHeaderGroupProps()} className={"t heightSet65"} style={{ width: '99.8%' }}>
                    <div className='slno th likeTh' >#</div>
                    {headerGroup.headers.map(column => {
                        k++;
                        return (
                            <React.Fragment key={column.id}>
                                <div {...column.getHeaderProps()} className={(rightBox.toString().indexOf(" " + k.toString() + ",") >= 0 ? 'th ' + column.render('classNameGet') + ' rightBoxCol' : centerBox.toString().indexOf(" " + k.toString() + ",") >= 0 ? 'th ' + column.render('classNameGet') + ' centerBoxCol' : 'th ' + column.render('classNameGet'))} name={(parseInt(k, 10) === parseInt(paddingShort, 10)) ? 'paddingSort' : ''}>
                                    {column.render('Header')}
                                    <span>
                                        {
                                            filterBoxNone.toString().indexOf(k.toString() + ",") > -1 ? <></> :
                                                column.canFilter ? column.render('Filter') : null
                                        }
                                    </span>
                                </div>
                                {k === getIndex ?
                                    <div className={"th likeTh centerBoxCol " + actionClass}>Action</div>
                                    : null}
                            </React.Fragment>
                        )
                    }
                    )}
                </div>
            ))}
            <div {...getTableBodyProps()} ref={tbodyRef} className="rowGroupContent">
                <FixedSizeList
                    height={setHeight && !isNaN(setHeight) ? parseFloat(setHeight) : 400}
                    itemCount={rows.length}
                    itemSize={50}
                    width={'100%'}
                    className="rowGroupContentChild"
                    ref={divRef}
                >
                    {RenderRow}
                </FixedSizeList>
            </div>
        </div>
    )
}

